import { ChevronDownIcon } from "@primer/octicons-react";
import { Button, SelectPanel } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { useCommonContext } from '../../contexts/common';
interface IComboboxCaAnProps {
    isReadonly?: boolean;
    value?: string;
    onValueChanged: (id: string, data?: any) => void;
    className?: string;
    isShowClearButton?: boolean;
    preText?: string;
    width?: string | number;
    stylingMode?: 'outlined' | 'filled' | 'underlined';
    showDescription?: boolean; // Prop để control hiển thị mô tả
    // sx?: BetterSystemStyleObject,
};
const ComboboxTrangThaiDiemDanhAn = (props: IComboboxCaAnProps) => {
    const [CaAn, setCaAn] = useState<any[]>([]);

    const [open, setOpen] = useState(false)
    const [filter, setFilter] = useState('')
    const { translate } = useCommonContext();
        useEffect(() => {
        handleGetCaAnAsync();
    }, [])

    const dataSource = useMemo(() => {
        return CaAn.map(x => ({
            id: x.id,
            text: x.name
        }))
    }, [CaAn, props.showDescription])
    const filteredItems = useMemo(() => {
        return dataSource.filter(item => item.text.toLowerCase().includes(filter.toLowerCase()))
    }, [dataSource, filter])
    const selected = useMemo(() => {
        return dataSource.find(x => x.id === props.value)
    }, [dataSource, props.value])


    const setSelected = (selecteds: any) => {
        if (selecteds)
            props.onValueChanged(selecteds.id)
    }
    const handleGetCaAnAsync = async () => {
        setCaAn([
            { id: 'all', name: "Tất cả" },
            { id: 'diemDanh', name: "Có điểm danh" },
            { id: 'hopLe', name: "Điểm danh hợp lệ" },
            { id: 'khongHopLe', name: "Điểm danh không hợp lệ" },
        ]);
    }
    return (
        <SelectPanel
            renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
                <Button
                    trailingAction={ChevronDownIcon}
                    aria-labelledby={` ${ariaLabelledBy}`} {...anchorProps}
                    sx={{
                        width: '100%'
                    }}
                >
                    <p style={{ width: '100%', overflow: "hidden", textOverflow: "ellipsis" }}>
                        {children || translate("Chọn trạng thái")}
                    </p>
                </Button>
            )}

            title={""}
            placeholderText="Search"
            open={open}
            onOpenChange={setOpen}
            items={filteredItems}
            selected={selected}
            onSelectedChange={setSelected}
            onFilterChange={setFilter}
            showItemDividers={true}
            overlayProps={{ width: 'small', height: 'medium' }}
        />
    );
};

export default ComboboxTrangThaiDiemDanhAn;